module.exports = __webpack_public_path__ + "img/TUTORIAL.5b384280.png";